<script setup>
import "@/assets/new-style/all.css";
import "@/assets/new-style/uikit.css";
import AboutModal from "@/components/general/AboutModal.vue";
import RedesignHelpModal from "@/components/general/RedesignHelpModal.vue";
import RedesignMobileNotification from "@/components/general/RedesignMobileNotification.vue";
import {errorHandler} from "@/lib/errorHandler";
import {targetActionsMap} from "@/lib/sendYmParams";
import {computed, nextTick, onMounted, ref, onBeforeUnmount} from "vue";
import {useRouter} from "vue-router";
import {useStore} from "vuex";

const openSelect2 = ref(false);

const store = useStore();

const router = useRouter();

const isReloadPage = computed(() => store.getters.isReloadPage);

if (isReloadPage.value) {
  window.location.reload();
} else {
  const notification = localStorage.getItem("notification");
  if (notification) {
    errorHandler({name: notification});
    localStorage.removeItem("notification");
  }
}

const size = {
  Vanya: 150,
  walk: 150,
  questions: 150,
  SRS: 150,
  russiaForum: 150,
  Chronicles: 150,
  Atom: 150,
};

const targetKey = {
  questions: 5,
  walk: 4,
  russiaForum: 2,
  Vanya: 3,
  Atom: 1,
};

const scrollToAnchor = (anchor, path = "/") => {
  if (targetKey[anchor]) {
    targetActionsMap.get(targetKey[anchor])();
  }

  setTimeout(() => {
    const el = document.getElementById(anchor);

    if (!el) {
      return router.push({path, hash: `#${anchor}`}).then(() => {
        const innerEl = document.getElementById(anchor);
        innerEl?.scrollIntoView({
          behavior: "smooth",
          inline: "start",
        });
      });
    }

    const elementRect = el.getBoundingClientRect();
    const bodyRect = document.body.getBoundingClientRect();
    const scrollPosition = elementRect.top - bodyRect.top - size[anchor];

    window.scrollTo({
      top: scrollPosition,
      behavior: "smooth",
    });
  });
};
const openMenu = ref(false);
const openHelpModal = ref(false);
const openAlert = ref(false);

function onClickTechSupport() {
  openHelpModal.value = !openHelpModal.value;
  targetActionsMap.get(2)();
}

const aboutModalOpen = ref(false);

onMounted(() => {
  nextTick(() => {
    setTimeout(() => {
      const anchor = router.currentRoute.value.hash;
      if (anchor.length) {
        const el = document.querySelector(anchor);
        const elementRect = el?.getBoundingClientRect();
        const bodyRect = document.body.getBoundingClientRect();

        const scrollPosition =
          elementRect.top - bodyRect.top - size[anchor.replace("#", "")];
        window.scrollTo({
          top: scrollPosition,
          behavior: "smooth",
        });
      }
    }, 300);
  });
});

const selectRef = ref(null);

const handleClickOutside = (e) => {
  if (selectRef.value && !selectRef.value.contains(e.target)) {
    openSelect2.value = false;
  }
};

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", handleClickOutside);
});
</script>

<template>
  <header class="header">
    <div class="header-filling container">
      <button
        class="header__burger mob"
        @click="openMenu = !openMenu"
        :class="{'header__burger--active': openMenu}">
        <span class="header__burger-bar"></span>
      </button>
      <router-link to="/" class="logo">
        <img src="@/assets/new-icons/logo.png" alt="Лого" class="logo" />
      </router-link>
      <div class="header-list desk" :class="{'header-list--open': openMenu}">
        <!-- <router-link
          :to="{name: 'NewYear'}"
          class="header-list__element header-list__element--last">
          Новогодние традиции в «цифре»
        </router-link> -->
        <div class="select" ref="selectRef">
          <button
            class="select__button"
            :class="{'select__button--open': openSelect2}"
            @click="openSelect2 = !openSelect2">
            Мероприятия
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.0001 9.00001L7.75708 13.242L9.17208 14.656L12.0001 11.828L14.8281 14.656L16.2431 13.242L12.0001 9.00001Z"
                fill="#000000" />
            </svg>
          </button>
          <div class="select-list" :class="{'select-list--open': openSelect2}">
            <a
              @click.prevent="scrollToAnchor('russiaForum')"
              @click="openSelect2 = !openSelect2"
              class="select-list__element"
              >Международная выставка-форум «Россия»
            </a>
            <a
              @click.prevent="scrollToAnchor('Vanya')"
              @click="openSelect2 = !openSelect2"
              class="select-list__element"
              >Экскурсия с Ваней Дмитриенко</a
            >
            <a
              @click.prevent="scrollToAnchor('walk')"
              @click="openSelect2 = !openSelect2"
              class="select-list__element"
              >Прогулка по МетаВДНХ</a
            >
            <a
              href="#Chronicles"
              @click.prevent="scrollToAnchor('Chronicles')"
              class="select-list__element"
              >Хроники Победы
            </a>
          </div>
        </div>
        <button
          class="header-list__element header-list__element--last"
          @click="aboutModalOpen = true">
          О проекте
        </button>
      </div>
      <button class="help" @click="onClickTechSupport">
        <img src="@/assets/new-icons/help-icon.png" alt="" class="help__icon" />
      </button>
      <router-link
        :to="{name: 'authorizationPage'}"
        v-if="
          $route.name === 'RedesignLandingPage' ||
          $route.name === 'FireworkPage'
        "
        class="header__link"
        @click="targetActionsMap.get(1)()"
        >Посетить <span class="desk"> МетаВДНХ</span></router-link
      >
      <!-- <a href="#SRS" @click.prevent="scrollToAnchor('SRS')" v-else class="header__link">Скачать ПО</a> -->
    </div>
    <div
      class="header-list header-list--mob mob trans"
      :class="{'header-list--open': openMenu}">
      <div class="header-list-content container">
        <!-- <router-link :to="{name: 'NewYear'}" class="header-list__element">
          Новогодние традиции в «цифре»
        </router-link> -->
        <a
          class="header-list__element"
          @click.prevent="scrollToAnchor('Chronicles')">
          Хроники Победы
        </a>
        <a @click.prevent="scrollToAnchor('Vanya')" class="header-list__element"
          >Экскурсия с Ваней Дмитриенко</a
        >
        <a @click.prevent="scrollToAnchor('walk')" class="header-list__element"
          >Прогулка по МетаВДНХ</a
        >
        <a
          @click.prevent="scrollToAnchor('russiaForum')"
          class="header-list__element"
          >Международная выставка-форум «Россия»
        </a>
        <button class="header-list__element" @click="aboutModalOpen = true">
          О проекте
        </button>
      </div>
    </div>
    <AboutModal
      v-if="aboutModalOpen"
      @close="aboutModalOpen = false"></AboutModal>
    <RedesignHelpModal
      v-if="openHelpModal"
      @close="openHelpModal = false"></RedesignHelpModal>
    <RedesignMobileNotification v-if="openAlert" @close="onCloseAlert" />
  </header>
</template>

<style lang="scss" scoped>
.mob {
  display: none;

  @media (max-width: 1100px) {
    display: inherit;
  }
}

.desk {
  @media (max-width: 1100px) {
    display: none;
  }
}

.header {
  position: sticky;
  top: 0;
  z-index: 12;
  background: #fff;

  &__burger {
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    flex-shrink: 0;

    @media (max-width: 1100px) {
      display: flex;
    }

    &-bar {
      position: relative;
      background: #000;
      transition: all 0ms 500ms;
      width: 1.03125rem;
      height: 0.1125rem;

      &:after {
        width: 1.03125rem;
        height: 0.1125rem;
        content: "";
        position: absolute;
        left: 0;
        top: 0.31875rem;
        background: #000;
        transition: top 500ms 500ms cubic-bezier(0.23, 1, 0.32, 1),
          transform 500ms cubic-bezier(0.23, 1, 0.32, 1);
      }

      &:before {
        width: 1.03125rem;
        height: 0.1125rem;
        content: "";
        position: absolute;
        left: 0;
        bottom: 0.31875rem;
        background: #000;
        transition: bottom 500ms 500ms cubic-bezier(0.23, 1, 0.32, 1),
          transform 500ms cubic-bezier(0.23, 1, 0.32, 1);
      }
    }

    &--active {
      .header__burger-bar {
        background: #fff;

        &:after {
          top: 0;
          transform: rotate(45deg);
          transition: top 500ms cubic-bezier(0.23, 1, 0.32, 1),
            transform 500ms 500ms cubic-bezier(0.23, 1, 0.32, 1);
        }

        &:before {
          bottom: 0;
          transform: rotate(-45deg);
          transition: bottom 500ms cubic-bezier(0.23, 1, 0.32, 1),
            transform 500ms 500ms cubic-bezier(0.23, 1, 0.32, 1);
        }
      }
    }
  }

  &-filling {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1.5rem 1rem;
    position: relative;

    @media (max-width: 1100px) {
      padding: 0.5rem 1rem;
      gap: 0.625rem;
    }

    .logo {
      display: flex;
      width: 8.5rem;

      @media (max-width: 1100px) {
        width: 6.375rem;
        margin-top: 0.06rem;
      }
    }
  }

  &-list {
    margin: 0 auto;
    display: flex;
    align-items: center;
    gap: 10px;

    &--mob {
      display: none;
    }

    &__element {
      font-weight: 500;
      font-size: 18px;
      line-height: 140%;
      padding: 10px 16px;
      background: none;
      transition: all 0.5s ease-in-out;
      border-radius: 24px;
      &:hover {
        background: #d72d41;
        color: #fff;
        opacity: 1;
      }
    }

    @media (max-width: 1310px) {
      gap: 5px;

      &__element {
        font-weight: 500;
        font-size: 16px;
        line-height: 140%;
        text-align: left;
      }
    }

    @media (max-width: 1140px) {
      margin-right: 0;
      gap: 1rem;
    }

    @media (max-width: 1100px) {
      position: absolute;
      transform: translateY(-10%);
      opacity: 0;
      left: 0;
      max-width: 100%;
      width: 100%;
      padding: 1rem 1rem;
      background: #fff;
      pointer-events: none;
      display: none;

      &--mob {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }

      &--open {
        transform: translateY(0);
        opacity: 1;
        pointer-events: all;
      }

      &-content {
        display: flex;
        flex-direction: column;
        gap: 1rem;
      }
    }
  }

  &__link {
    font-weight: 600;
    font-size: 1rem;
    line-height: 125%;
    background: #d72d41;
    color: #fff;
    border-radius: 3.5rem;
    padding: 0.875rem 1.25rem;

    @media (max-width: 1100px) {
      margin-left: 0;
      padding: 0.625rem 1rem;
      font-size: 0.88rem;
    }
  }
}

.select {
  position: relative;

  &__button {
    padding: 9.5px 16px 9.5px 24px;
    background: none;
    transition: all 0.5s ease-in-out;
    border-radius: 24px;
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 500;
    font-size: 18px;
    line-height: 140%;
    color: #000;

    &-span {
      padding-left: 20px;
    }

    svg {
      transform: rotate(180deg);
      transition: all 0.5s ease-in-out;

      path {
        transition: all 0.5s ease-in-out;
      }
    }

    &:hover {
      background: #d72d41;
      color: #fff;
      opacity: 1;

      svg {
        path {
          fill: #fff;
        }
      }
    }

    &--open {
      background: #d72d41;
      border-radius: 24px 24px 0 0;
      color: #fff;

      svg {
        transform: rotate(0deg);

        path {
          fill: #fff;
        }
      }
    }

    &--1 {
      opacity: 1;
      padding: 10px 16px;
    }
  }

  &__img {
    position: absolute;
    left: 78px;
  }

  &-list {
    position: absolute;
    display: flex;
    flex-direction: column;
    text-align: right;
    width: 333px;
    right: 0;
    border-radius: 24px 0 24px 24px;
    background: #d72d41;
    padding: 24px;
    gap: 24px;
    transition: all 0.5s ease-in-out;
    opacity: 0;
    pointer-events: none;

    &--open {
      opacity: 1;
      pointer-events: all;
    }

    &__element {
      font-weight: 500;
      font-size: 18px;
      line-height: 140%;
      color: #fff;

      &:hover {
        opacity: 0.5;
      }
    }
  }

  &--1 {
    .select-list {
      margin-top: 4px;
      width: 100%;
      border-radius: 4px 4px 24px 24px;
    }
  }

  @media (max-width: 1310px) {
    &__button {
      padding: 9.5px 12px 9.5px 16px;
      gap: 6px;
      font-size: 16px;

      svg {
        transform: rotate(180deg);
        transition: all 0.5s ease-in-out;

        path {
          transition: all 0.5s ease-in-out;
        }
      }

      &:hover {
        background: #d72d41;
        color: #fff;
        opacity: 1;

        svg {
          path {
            fill: #fff;
          }
        }
      }

      &--open {
        background: #d72d41;
        border-radius: 24px 24px 0 0;
        color: #fff;

        svg {
          transform: rotate(0deg);

          path {
            fill: #fff;
          }
        }
      }
    }

    &__img {
      position: absolute;
      left: 68px;
    }
  }
}

.help {
  display: flex;
  padding: 0.5rem;
  background: #f3f4f6;
  border-radius: 100%;

  &__icon {
    width: 32px;
    height: 32px;
  }

  @media (max-width: 1100px) {
    margin-left: auto;
    padding: 0.55rem;
  }
}
</style>
